/**
 * The angularjs states related to the module LinkShortenerModule
 */
customEventsStates.$inject = ['$stateProvider'];
export function customEventsStates($stateProvider) {
    $stateProvider
        .state('auth.alcmeon.fuse.parameters.custom-events', {
            url: '/custom-events',
            abstract: true,
        })
        .state('auth.alcmeon.fuse.parameters.custom-events.search', {
            url: '',
            views: {
                'container@auth': {
                    template: '<angular-custom-events></angular-custom-events>',
                }
            }
        })
        .state('auth.alcmeon.fuse.parameters.custom-events.create', {
            url: '/create',
            data: { create: true },
            views: {
                'container@auth': {
                    template: '<angular-custom-event></angular-custom-event>',
                }
            }
        })
        .state('auth.alcmeon.fuse.parameters.custom-events.details', {
            url: '/:customEventId',
            views: {
                'container@auth': {
                    template: '<angular-custom-event></angular-custom-event>',
                }
            }
        })
}